//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as uiAction from '../action/uiAction';
//Func
import { lsProfileCommentInit } from '../func/lsProfileComment';
//Material-ui
import Button from '@material-ui/core/Button';
//Add
import TextareaAutosize from 'react-textarea-autosize';
//Part
import PartMyProfileStep from './PartMyProfileStep';
import DialogProfileCommentTemplate from './DialogProfileCommentTemplate';
import PartPageTitle from './PartPageTitle';



class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      userdata_prof_comment: '',
      userdata_prof_partner_comment: '',
      templateDialogVisible: false,

      commentFocus: false,
      partnerCommentFocus: false,
    }
    if (!localStorage.getItem('ProfileComment')) {
      lsProfileCommentInit();
    }
	}

  componentDidMount() {
    document.title = 'プロフィール(コメント) - パートナーズ';
    if (this.props.history.action === 'PUSH') {
      window.scrollTo(0, 0);
    }
    let lsObj = JSON.parse(localStorage.getItem('ProfileComment'));
    if (lsObj.comment || lsObj.profileComment) {
      this.setState({
        userdata_prof_comment: lsObj.comment,
        userdata_prof_partner_comment: lsObj.profileComment,
      });
    }
    else if (this.props.my.request.profileLog.comment) {
      this.setState({
        userdata_prof_comment: this.props.my.request.profileLog.comment,
        userdata_prof_partner_comment: this.props.my.request.profileLog.partnerComment,
      });
    }
    else if (this.props.my.profile.datetime) {
      this.setState({
        userdata_prof_comment: this.props.my.profile.userdata_prof_comment,
        userdata_prof_partner_comment: this.props.my.profile.userdata_prof_partner_comment,
      })
    }
  }

  _saveSubmit() {
    this.props.myProfileCommentSave(this.state.userdata_prof_comment, this.state.userdata_prof_partner_comment, (data) => {
      lsProfileCommentInit();
      if (this.props.location.pathname.match(/^\/new\//)) {
        if (!this.props.my.setting.email) {
          this.props.history.push('/new/emailAuth/');
        }
        else {
          this.props.history.push('/new/proofPersonDirect/');
        }
      }
      else {
        this.props.history.push('/my/#myProfileCommentBox');
      }
      if (this.props.my.setting.profileWebmasterCheck === 0) {
        window.gtag("event", 'profile_register');

      }
    })
  }

  _saveLs() {
    var obj = {
      comment: this.state.userdata_prof_comment,
      profileComment: this.state.userdata_prof_partner_comment,
    };
    localStorage.setItem('ProfileComment', JSON.stringify(obj));
    this.props.snackOpen('success', '保存しました', 5000);
  }

  _scroll() {
    const hash = window.location.hash.replace("#", "");
    if (hash) {

      let elem = document.getElementById(hash);
      if (elem) {
        let rect = elem.getBoundingClientRect();
        window.scrollTo(0, (window.pageYOffset + rect.top - document.getElementById('header_menu').clientHeight));
      }
    }
  }

  _templateDialogVisibleEdit(bool) {
    this.setState({ templateDialogVisible: bool });
  }

  _commentTemplate2state(value) {
    this.setState({ userdata_prof_comment: value});
  }

  _later() {
    this.props.myProfileCheck((data) => {
      if (!this.props.my.setting.email) {
        this.props.history.push('/new/emailAuth/');
      }
      else {
        this.props.history.push('/new/proofPersonDirect/');
      }
    });
  }

  _profileBack() {
    if(window.confirm('コメントを書き換えてもいいですか？')) {
      this.setState({
        userdata_prof_comment: this.props.my.profile.userdata_prof_comment,
        userdata_prof_partner_comment: this.props.my.profile.userdata_prof_partner_comment,
      });
    }
  }

  render() {

    let errorCount = 0;
    let commentValidationComment;
    if (this.state.userdata_prof_comment.length < 30) {
      commentValidationComment = (<span style={{color:'red'}}>30文字以上記入してください</span>);
      errorCount++;
    }
    else if (this.state.userdata_prof_comment.length > 1000) {
      commentValidationComment = (<span style={{color:'red'}}>1000文字以内で記入してください</span>);
      errorCount++;
    }


    let partnerCommentValidationComment;
    if (this.state.userdata_prof_partner_comment.length > 100) {
      partnerCommentValidationComment = (<span style={{color:'red'}}>100文字以内で記入してください</span>);
      errorCount++;
    }
    else if (this.state.userdata_prof_partner_comment.length> 30) {
      partnerCommentValidationComment = (<span style={{color:'orange'}}>さがす(会員検索)では30文字以上はトリミングされ表示されない場合があります。</span>);
    }
    else if ((/[\n\r]/.test(this.state.userdata_prof_partner_comment)) === true) {
      partnerCommentValidationComment = (<span style={{color:'orange'}}>さがす(会員検索)では改行は無効になる場合があります。</span>);
    }


    let submitDisabled;
    if (errorCount > 0) {
      submitDisabled = true;
    }
    else {
      submitDisabled = false;
    }

    return (
      <div>
        {
          (this.props.location.pathname.match(/^\/new\//)) ? (
            <div>
              <PartMyProfileStep step={2} />
              <h1 align='center'>コメント</h1>
            </div>
          ) : (
            <PartPageTitle
              title={'コメント'}
              onback={ '/my/' }
            />
          )
        }


        <div style={{maxWidth:'600px',margin:'auto'}}>

          <div style={{margin:"15px"}} id='comment'>
            <span style={{display:'inline-block', position:'relative'}}>
              <h3 align='left'>
                自己紹介
              </h3>
            </span>

            <div>

              <Button
                variant="outlined"
                color='primary'
                onClick={ () => this._templateDialogVisibleEdit(true) }
              >
                <span style={{fontSize: '1.2em'}}>らくらくコメント作成</span>
              </Button>
              <div style={{color:'#666'}}>質問にクリックで回答するだけで、簡単にコメントが作成できます。</div>
            </div>

            <DialogProfileCommentTemplate
              open={this.state.templateDialogVisible}
              close={ () => this._templateDialogVisibleEdit(false) }
              submit={ (value) => this._commentTemplate2state(value) }
            />

            <div style={{margin:'10px 0px'}}>
              <div style={{color:'#666'}}>
                30 〜 1000文字
              </div>
              <TextareaAutosize
                id='profComment'
                value={this.state.userdata_prof_comment}
                className= {(commentValidationComment) ? "input_red round6" : "input_blue round6"}
                onChange={(event) => this.setState({ userdata_prof_comment: event.target.value})}
                style={{
                  fontSize: '1.2em',
                }}
                minRows={6}
                maxRows={100}
                onHeightChange={ ()=> this._scroll() }
                placeholder='プロフィールに表示される自己紹介'
              >
              </TextareaAutosize>
              {commentValidationComment}
              <div align='right'>
                {this.state.userdata_prof_comment.length}文字
              </div>
            </div>
          </div>

          {
            (!this.props.location.pathname.match(/^\/new\//)) && (
              <div style={{margin:"15px"}} id='partnerComment'>
                <h3 align='left'>
                  パートナーに一言
                </h3>

                <div style={{margin:'10px 0px'}}>
                  <div style={{color:'#666'}}>
                    100文字以内 (30文字以内推奨)
                  </div>
                  <TextareaAutosize
                    value={this.state.userdata_prof_partner_comment}
                    className= {(partnerCommentValidationComment) ? "input_red round6" : "input_blue round6"}
                    onChange={(event) => this.setState({ userdata_prof_partner_comment: event.target.value})}
                    style={{
                      fontSize: '1.2em',
                    }}
                    placeholder='会員検索などに吹き出しで表示されます'
                  >
                  </TextareaAutosize>
                  {partnerCommentValidationComment}
                  <div align='right'>
                    {this.state.userdata_prof_partner_comment.length}文字
                  </div>
                </div>
              </div>
            )
          }

          <div style={{margin:'10px'}} align='right'>
            {
              (!this.props.location.pathname.match(/^\/new\//)) && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={ () => this._profileBack() }
                >
                  掲載中のコメントに戻す
                </Button>
              )
            }
            &nbsp;
            <Button
              variant="outlined"
              color='primary'
              onClick={ () => this._saveLs() }
              disabled={submitDisabled}
            >
               途中保存
            </Button>
          </div>

          <div align='center'style={{margin:'15px'}}>
            <Button
              variant="contained"
              color='primary'
              onClick={ () => this._saveSubmit() }
              style={{maxWidth:'400px', width:'100%',}}
              disabled={submitDisabled}
            >
              <div style={{fontSize:'1.4em'}}>コメントを登録する</div>
            </Button>
          </div>

        </div>

      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
		ui: state.ui,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
